.content {
  background: white;
  position: absolute;
  top: 0;
  left: calc(100% + 0.25em);
  padding: 0.5em;
  z-index: 1;
  margin-top: 0 !important;
}

.buttonContainer {
  background-color: white;
  position: relative;
  display: inline;
}
